<template>
  <v-container
    fluid
    class="mt-2"
    :class="
      $vuetify.breakpoint.mdAndUp
        ? 'py-5 px-10'
        : '' && $vuetify.breakpoint.smAndUp
        ? 'py-2 px-2'
        : ''
    "
  >
    <h1 class="mb-8">
      Page not found
    </h1>

    <p v-html="html" />
  </v-container>
</template>

<script>
export default {
  name: 'NOTFOUND',
  metaInfo: {
    title: 'Page not found',
    titleTemplate: '%s | LinkBook.io',
    meta: [
      {
        name: 'description',
        content:
          "LinkBook.io is a network hub that allows you to bookmark your bookmarks easily and efficiently which can be accessed from any device. The potential for users to benefit from this are anyone that's studying, researching or exploring their interests. LinkBook.io makes life easier to find the websites you're looking for and access your favourite websites instantly."
      }
    ]
  },
  data() {
    return {
      companyName: 'LinkBook.io',
      linkparams: null,
      editmodal: false,
      html: `<div class="card-body"> 
         <h3 class="cf-text cf-text--header cf-text--h3">
            Looks like you've followed a broken link or entered a URL that doesn't exist on this site. <a href='/'>Back to our site</a>
         </h3>         
      </div>`
    }
  }
}
</script>
